// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1yLmZ","requiredAsterisk":"Info_requiredAsterisk__2wMeW"};